export default __webpack_public_path__ + "static/media/Gym.cadc4f23.jpg";